<template>
  <Modal
    :value="noticeVisible"
    :scrollable="true"
    :mask-closable="false"
    :closable="false"
    :transfer="false"
    width="100%"
    class-name="notice-config"
    :footer-hide="true"
    @on-cancel="handleCancel">
    <v-loading :loading="loading"></v-loading>
    <div class="notice-config__header flex flex--align-center flex--justify-between">
      <h2 class="title">余额和服务提醒</h2>
      <div class="action">
        <Button type="text" @click="handleCancel">取消</Button>
        <Button type="primary" shape="circle" @click="handleUpdateConfig">更新设置</Button>
      </div>
    </div>
    <div class="notice-config__body" :style="{maxHeight: configBodyHeight}">
      <div :class="balanceClasses">
        <div class="title flex flex--justify-between flex--align-center">
          <h3>余额提醒</h3>
          <v-switch :themeColor="balance.enable ? 'primary' : 'disabled'"
                    v-model="balance.enable"></v-switch>
        </div>
        <div class="content">
          <Form>
            <FormItem label="预警余额（元/只能为整数）">
              <v-format-input v-model="balance.warnNum"
                              type="text"
                              placeholder="100"
                              format="positiveIntegerAndZero"
                              @on-focus="handleSetValue('balance', 'warnNum', '100')"
                              :disabled="!balance.enable" 
                              >
                <span class="right-text">.00 元整</span>
              </v-format-input>
            </FormItem>
          </Form>
        </div>
      </div>
      <div :class="serviceClasses">
        <div class="title flex flex--justify-between flex--align-center">
          <h3>服务提醒</h3>
          <v-switch :themeColor="service.enable ? 'primary' : 'disabled'"
                    v-model="service.enable"></v-switch>
        </div>
        <div class="content">
          <Form>
            <FormItem label="剩余调用次数（次/只能为整数）">
              <v-format-input v-model="service.warnLastNum"
                              type="text"
                              placeholder="100"
                              format="positiveIntegerAndZero"
                              @on-focus="handleSetValue('service', 'warnLastNum', '100')"
                              :disabled="!service.enable" 
                              >
                <span class="right-text">次</span>
              </v-format-input>
            </FormItem>
            <FormItem label="剩余有效时间（天/只能为整数）">
              <v-format-input v-model="service.warnLastDay"
                              type="text"
                              placeholder="7"
                              format="positiveIntegerAndZero"
                              @on-focus="handleSetValue('service', 'warnLastDay', '7')"
                              :disabled="!service.enable" 
                              >
                <span class="right-text">天</span>
              </v-format-input>
            </FormItem>
          </Form>
        </div>
      </div>
      <div class="notice-config__body-section">
        <div class="title flex flex--justify-between flex--align-center">
          <h3>提醒方式</h3>
        </div>
        <div class="content type">
          <div class="platform flex flex--align-center flex--justify-between">
            <v-icon type="iconcomputer-24px"
                    right-text="平台消息推送"></v-icon>
            <p>*必选，不可修改</p>
          </div>
          <div :class="phoneClasses">
            <div class="flex flex--align-center">
              <v-icon type="iconstay_current_portrait-24px"></v-icon>
              <div class="info">
                <p>手机短信推送：{{phone}}</p>
                <p>如果需要修改手机号，请前往【账户信息】里修改</p>
              </div>
            </div>
            <v-switch :themeColor="typeData.phoneEnable ? 'primary' : 'disabled'"
                      v-model="typeData.phoneEnable"></v-switch>
          </div>
          <div :class="emailClasses" v-if="email">
            <div class="flex flex--align-center">
              <v-icon type="iconstay_current_portrait-24px"></v-icon>
              <div class="info">
                <p>电子邮箱通知：{{email}}</p>
                <p>如果需要修电子邮箱，请在【账户信息】里修改</p>
              </div>
            </div>
            <v-switch :themeColor="typeData.emailEnable ? 'primary' : 'disabled'"
                      v-model="typeData.emailEnable"></v-switch>
          </div>
          <template v-else>
            <div class="email disabled flex flex--align-center flex--justify-between"
                 v-if="!isUpdateEmail">
              <div class="flex flex--align-center">
                <v-icon type="iconemail-24px1"></v-icon>
                <div class="info">
                  <p>暂未绑定邮箱</p>
                </div>
              </div>
              <div class="action" @click="handleSwitchIsUpdate">添加邮箱</div>
            </div>
            <div class="update-email"
                 v-else>
              <div class="line1 flex flex--align-center"
                   v-if="updateStep === 1">
                <v-icon type="iconemail-24px1"
                        :right-text="`电子邮箱通知：${updateEmailData.email}`"></v-icon>
                <span>（未激活）</span>
              </div>
              <Form>
                <FormItem v-if="updateStep === 0">
                  <Input type="text"
                         placeholder="请输入电子邮箱地址"
                         v-model="updateEmailData.email"></Input>
                  <p class="update-email__action update-email__action--cancel"
                     @click="handleSwitchIsUpdate">取消操作</p>
                  <p :class="validateEmailClasses" @click="handleValidateEmailFormat">验证邮箱</p>
                </FormItem>
                <FormItem v-if="updateStep === 1">
                  <Input type="text"
                         placeholder="请输入邮箱验证码"
                         v-model="updateEmailData.validateCode"></Input>
                  <p :class="sendClasses" @click="handleSendMsg">{{sendText}}</p>
                  <p :class="validateCodeClasses" @click="handleUpdateSubmit">验证邮箱</p>
                </FormItem>
              </Form>
            </div>
          </template>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex';
import { sendEmailCode, updateEmail, checkEmailExist } from '@/api/user/user';

export default {
  name: 'noticeConfig',
  data() {
    return {
      balance: {
        enable: true,
        warnNum: '',
      },
      service: {
        enable: true,
        warnLastNum: '',
        warnLastDay: '',
      },
      typeData: {
        phoneEnable: true,
        emailEnable: true,
      },
      updateEmailData: {
        email: '',
        validateCode: '',
      },
      isUpdateEmail: false,
      updateStep: 0,
      sendStep: 0,
      sendCountDown: 60,
      timer: null,
      submitLoading: false,
      loading: false,
    };
  },
  computed: {
    ...mapState(['noticeVisible', 'windowSize']),
    ...mapState('user', ['email', 'phone']),
    ...mapState('message', ['config']),
    configBodyHeight() {
      return `${this.windowSize.height - 182}px`;
    },
    balanceClasses() {
      const classes = ['notice-config__body-section'];
      if (!this.balance.enable) {
        classes.push('disabled');
      }
      return classes;
    },
    serviceClasses() {
      const classes = ['notice-config__body-section'];
      if (!this.service.enable) {
        classes.push('disabled');
      }
      return classes;
    },
    phoneClasses() {
      const classes = ['phone', 'flex', 'flex--align-center', 'flex--justify-between'];
      if (!this.typeData.phoneEnable) {
        classes.push('disabled');
      }
      return classes;
    },
    emailClasses() {
      const classes = ['email', 'flex', 'flex--align-center', 'flex--justify-between'];
      if (!this.typeData.emailEnable) {
        classes.push('disabled');
      }
      return classes;
    },
    sendText() {
      return ['再次发送', '发送中', `再次发送${this.sendCountDown}s`][this.sendStep];
    },
    sendClasses() {
      const classes = ['update-email__action', 'update-email__action--send'];
      if (this.sendStep > 0) {
        classes.push('disabled');
      }
      return classes;
    },
    validateEmailClasses() {
      const classes = ['update-email__action', 'update-email__action--validate'];
      if (!this.updateEmailData.email) {
        classes.push('disabled');
      }
      return classes;
    },
    validateCodeClasses() {
      const classes = ['update-email__action', 'update-email__action--validate'];
      if (!this.updateEmailData.validateCode || this.submitLoading) {
        classes.push('disabled');
      }
      return classes;
    },
  },
  watch: {
    noticeVisible(val) {
      if (val) {
        this.isUpdateEmail = false;
        this.resetData();
      }
    },
    config(val) {
      if (val) {
        this.resetConfigData();
      }
    }
  },
  methods: {
    ...mapActions({
      getConfig: 'message/getMsgConfig',
      updateConfig: 'message/updateMsgConfig',
    }),
    ...mapMutations(['updateState']),
    handleCancel() {
      this.updateState({
        noticeVisible: false,
      });
      this.resetConfigData();
    },
    handleSwitchIsUpdate() {
      this.isUpdateEmail = !this.isUpdateEmail;
      if (!this.isUpdateEmail) {
        this.resetData();
      }
    },
    resetData() {
      this.updateEmailData = {
        email: '',
        validateCode: '',
      };
      this.updateStep = 0;
      this.sendStep = 0;
      this.sendCountDown = 60;
    },
    resetConfigData() {
      if (this.config) {
        this.loading = false;
        this.balance.enable = this.config.amount_remind;
        this.balance.warnNum = this.config.amount.toString();
        this.service.enable = this.config.service_remind;
        this.service.warnLastNum = this.config.service_count.toString();
        this.service.warnLastDay = this.config.service_days.toString();
        this.typeData.phoneEnable = this.config.by_phone;
        this.typeData.emailEnable = this.config.by_email;  
      } else {
        this.loading = false;
        this.balance.enable = true;
        this.balance.warnNum = '';
        this.service.enable = true;
        this.service.warnLastNum = '';
        this.service.warnLastDay = '';
        this.typeData.phoneEnable = true;
        this.typeData.emailEnable = true; 
      }
    },
    async handleSendMsg() {
      if (this.sendStep) {
        return false;
      }
      this.sendStep = 1;
      // 调用后端发送验证码接口
      const res = await sendEmailCode({
        email: this.updateEmailData.email,
      });
      if (res) {
        this.sendStep = 2;
        this.timer = setInterval(() => {
          this.sendCountDown -= 1;
          if (this.sendCountDown <= 0) {
            this.sendStep = 0;
            clearInterval(this.timer);
            this.sendCountDown = 60;
          }
        }, 1000);
      } else {
        this.sendStep = 0;
      }
      return true;
    },
    async handleValidateEmailFormat() {
      if (!this.$rules.email.pattern.test(this.updateEmailData.email)) {
        this.$Message.error('邮箱格式不正确，请重新输入');
        return false;
      }
      const res = await checkEmailExist({
        email: this.updateEmailData.email,
      });
      if (res && !res.exists) {
        this.handleSendMsg();
        this.updateStep = 1;
      } else {
        this.$Message.error('此邮箱已被注册，请另换一个');
      }
      return true;
    },
    async handleUpdateSubmit() {
      if (this.submitLoading) {
        return false;
      }
      const {
        email, validateCode,
      } = this.updateEmailData;
      this.submitLoading = true;
      const res = await updateEmail({
        email,
        email_code: validateCode,
      });
      if (res) {
        this.$Message.success('添加成功');
        this.$store.commit('user/updateState', {
          email: res.email,
        });
      }
      this.submitLoading = false;
      return false;
    },
    handleSetValue(form, key, value) {
      if (!this[form][key]) {
        this[form][key] = value;
      }
    },
    handleUpdateConfig() {
      const newConfig = {
        id: this.config.id,
        amount_remind: this.balance.enable,
        amount: this.balance.warnNum || 100,
        service_remind: this.service.enable,
        service_count: this.service.warnLastNum || 100,
        service_days: this.service.warnLastDay || 7,
        by_phone: this.typeData.phoneEnable,
        by_email: this.typeData.emailEnable,
      }
      this.updateConfig(newConfig);
      this.updateState({
        noticeVisible: false,
      });
    }
  },
  created() {
    this.loading = true;
    this.getConfig();
  }
};
</script>

<style lang="less">
  .notice-config{
    &.ivu-modal-wrap{
      overflow: hidden;
    }
    .ivu-modal{
      max-width: 1008px;
      top: 112px;
    }
    .ivu-modal-body{
      padding: 0;
    }
    &__main{
      overflow: auto;
    }
    &__header{
      padding: 16px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.12);
      .title{
        color: rgba(0, 0, 0, 0.54);
        font-size: 24px;
        line-height: 32px;
      }
      .action{
        .ivu-btn{
          padding: 0;
          height: 36px;
          width: 88px;
          font-weight: 500;
          &.ivu-btn-text{
            color: @primary-color;
            box-shadow: none;
          }
          &[disabled]{
            background-color: rgba(0, 0, 0, 0.12);
            color: rgba(0, 0, 0, 0.26);
          }
        }
      }
    }
    &__body{
      padding: 16px 8px;
      overflow: auto;
      &-section{
        background-color: rgba(0, 0, 0, 0.08);
        border-radius: 8px;
        height: 280px;
        margin-bottom: 8px;
        &.disabled{
          .title{
            h3{
              color: rgba(0, 0, 0, 0.26);
            }
          }
          .content{
            .ivu-form-item-label{
              color: rgba(0, 0, 0, 0.26);
            }
            .right-text{
              color: rgba(0, 0, 0, 0.26);
            }
          }
        }
        .title{
          height: 55px;
          padding: 0 16px;
          border-bottom: 1px solid rgba(0, 0, 0, 0.12);
          h3{
            color: rgba(0, 0, 0, 0.87);
            font-size: 18px;
            line-height: 22px;
          }
        }
        .content{
          padding: 24px 16px;
          &.type{
            padding: 0;
          }
          .right-text{
            margin-left: 5px;
            color: rgba(0, 0, 0, 0.54);
          }
          .platform{
            height: 38px;
            border-bottom: 1px solid rgba(0, 0, 0, 0.12);
            padding: 0 16px;
            .v-icon{
              color: rgba(0, 0, 0, 0.54);
            }
            .icon-right-text{
              color: rgba(0, 0, 0, 0.54);
            }
            >p{
              color: rgba(0, 0, 0, 0.26);
              font-weight: 500;
            }
          }
          .phone, .email{
            padding: 22px 16px;
            color: rgba(0, 0, 0, 0.54);
            &.disabled{
              color: rgba(0, 0, 0, 0.26);
              .v-icon{
                color: rgba(0, 0, 0, 0.26);
              }
            }
            .info{
              padding-left: 8px;
            }
            .v-icon{
              color: rgba(0, 0, 0, 0.54);
            }
            p{
              line-height: 16px;
              &:nth-child(2){
                font-size: 12px;
                margin-top: 4px;
                color: rgba(0, 0, 0, 0.26);
              }
            }
            .action{
              color: @primary-color;
              font-weight: 500;
              cursor: pointer;
            }
          }
          .update-email{
            padding: 22px 16px;
            /*.ivu-input-wrapper{
              width: 888px;
            }*/
            &__action{
              position: absolute;
              line-height: 36px;
              cursor: pointer;
              top: 0;
              &--cancel{
                right: 75px;
                color: rgba(0, 0, 0, 0.54);
                font-weight: 500;
                &:hover{
                  color: rgba(0, 0, 0, 0.67);
                }
              }
              &--send{
                right: 75px;
                color: @primary-color;
                font-weight: 500;
                &:hover{
                  color: @link-hover-color;
                }
                &.disabled{
                  color: rgba(0, 0, 0, 0.26);
                  cursor: no-drop;
                  &:hover{
                    color: rgba(0, 0, 0, 0.26);
                  }
                }
              }
              &--validate{
                right: 0;
                line-height: 36px;
                color: @primary-color;
                &:hover{
                  color: @link-hover-color;
                }
                &.disabled{
                  color: rgba(0, 0, 0, 0.26);
                  cursor: no-drop;
                  &:hover{
                    color: rgba(0, 0, 0, 0.26);
                  }
                }
              }
            }
            .v-icon{
              color: rgba(0, 0, 0, 0.26);
            }
            .line1 {
              line-height: 24px;
              margin-bottom: 8px;
              >span{
                color: rgb(255, 152, 0);
              }
            }
            .ivu-form-item{
              position: relative;
            }
          }
          .ivu-form-item-label{
            color: rgba(0, 0, 0, 0.54);
          }
          .ivu-input-wrapper{
            width: ~'calc(100% - 65px)';
          }
          .ivu-input{
            height: 36px;
            border-radius: 8px;
            padding: 8px 16px;
            font-size: 14px;
            line-height: 20px;
            border: none;
            box-shadow: none;
            color: rgba(0, 0, 0, 0.87);
            &[disabled]{
              background-color: rgba(0, 0, 0, 0.08);
              color: rgba(0, 0, 0, 0.26);
            }
          }
        }
      }
    }
  }
</style>
